import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    focusGlobalSearch: false,
    openMobileSearch: false,
  },
  reducers: {
    requestFocusGlobalSearch: (state) => {
      state.focusGlobalSearch = true;
    },
    clearGlobalSearchFocus: (state) => {
      state.focusGlobalSearch = false;
    },
    openMobileSearch: (state) => {
      state.openMobileSearch = true;
    },
    closeMobileSearch: (state) => {
      state.openMobileSearch = false;
    },
  },
});

export const {
  requestFocusGlobalSearch,
  clearGlobalSearchFocus,
  openMobileSearch,
  closeMobileSearch,
} = uiSlice.actions;

export default uiSlice.reducer;
